import { Job, Seniority, User } from '@clearkit/icons';
import { CKBox } from 'clearkit';

import { useProspector } from '../useProspector';
import { FilterMultiPicker } from './FilterMultiPicker';
import { FiltersPeople } from './types';

type FiltersPersonProps = {
  onChange: (value: FiltersPeople) => void;
};

export const SectionFiltersPeople = ({ onChange }: FiltersPersonProps) => {
  const [state] = useProspector();

  const filters = state.context.personQuery;

  const updateFilters = (key: keyof FiltersPeople) => (value: string[]) => {
    const newFilters = { ...filters, [key]: value };
    onChange(newFilters);
  };

  return (
    <div className="space-y-4">
      <h2 className="font-medium">People</h2>
      <CKBox className="p-4 divide-y space-y-3 divide-gray-200">
        <FilterMultiPicker
          items={state.context.prospectFilters?.title}
          onChange={updateFilters('title')}
          value={filters.title}
        >
          <FilterMultiPicker.Icon>
            <User />
          </FilterMultiPicker.Icon>
          <FilterMultiPicker.Title>Title Keywords</FilterMultiPicker.Title>
        </FilterMultiPicker>
        <FilterMultiPicker
          canAddCustomValue={false}
          className="pt-3"
          items={state.context.prospectFilters?.role}
          onChange={updateFilters('role')}
          value={filters.role}
        >
          <FilterMultiPicker.Icon>
            <Job />
          </FilterMultiPicker.Icon>
          <FilterMultiPicker.Title>Role</FilterMultiPicker.Title>
        </FilterMultiPicker>
        <FilterMultiPicker
          canAddCustomValue={false}
          className="pt-3"
          items={state.context.prospectFilters?.seniority}
          onChange={updateFilters('seniority')}
          value={filters.seniority}
        >
          <FilterMultiPicker.Icon>
            <Seniority />
          </FilterMultiPicker.Icon>
          <FilterMultiPicker.Title>Seniority</FilterMultiPicker.Title>
        </FilterMultiPicker>
      </CKBox>
    </div>
  );
};
